import $ from 'jquery';

const copyLink = () => {
	const el = {
		button: '#copy-link',
	};

	const init = () => {
		$(document).on('click', el.button, function (e) {
			e.preventDefault();

			var $btn = $(this);
			var url = window.location.href.split('#')[0];

			$('.copy-tooltip').remove();

			var $tooltip = $('<div class="copy-tooltip">Gekopieerd!</div>').appendTo('body');

			var offset = $btn.offset();
			var width = $btn.outerWidth();
			$tooltip.css({
				top: offset.top - 40,
				left: offset.left + width / 2,
				transform: 'translateX(-50%)',
				position: 'absolute',
				zIndex: 9999,
			});

			finish($tooltip);

			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(url).then(finish).catch(console.error);
			} else {
				var $temp = $('<textarea>');
				$('body').append($temp);
				$temp.val(url).select();
				try {
					document.execCommand('copy');
					finish();
				} catch (err) {
					console.error('Mislukt', err);
				}
				$temp.remove();
			}
		});
	};

	function finish(el) {
		setTimeout(function () {
			el.fadeOut(300, function () {
				$(this).remove();
			});
		}, 1200);
	}

	init();
};

try {
	copyLink();
} catch (error) {
	console.error(error);
}
